import { Flex, Text } from '@mantine/core';
import { FundDealLinkRes } from '@dealstack/shared/lib/generated';
import { EditableTileContainer } from '@dealstack/frontend/shared/components/EditableTileContainer/EditableTileContainer.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import React from 'react';
import { generatePath } from 'react-router-dom';
import { DEAL_ROUTES, PEOPLE_ROUTES, ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { StyledLink } from '@dealstack/frontend/shared/components/UserRowWithActions/styled.tsx';

interface Props {
	deal: FundDealLinkRes;
	personId: string;
	hasEditPermission: boolean;
	onDeleteClick: (deal: FundDealLinkRes) => void;
}

export const FundPersonDealLinkTile = ({
	deal,
	onDeleteClick,
	hasEditPermission,
	personId,
}: Props) => {
	const dealLink = generatePath(
		`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}${PEOPLE_ROUTES.PERSON_DETAILS}`,
		{
			dealId: deal.dealId,
			personId,
		}
	);
	return (
		<EditableTileContainer
			hasEditPermission={hasEditPermission}
			onDeleteClick={() => onDeleteClick(deal)}
			dataTestId={TEST_ELEMENT_IDS.FUND_PERSON_DEAL_LINK_TILE}
			deleteBtnDataTestId={TEST_ELEMENT_IDS.FUND_PERSON_DEAL_LINK_DELETE}
		>
			<Flex direction="column" gap="0.25rem">
				<StyledLink to={dealLink}>
					<Text fw={600}>{deal.dealName}</Text>
				</StyledLink>
			</Flex>
		</EditableTileContainer>
	);
};
